const sameId = (left, right) => String(left) === String(right);
const phoneKey = (value) => String(value || "").replace(/\D/g, "");

export function resolveSaleSource(records, target, phoneFields) {
  const sourceId = target?.sourceId ?? target?.entityId;
  const sourceStoreId = target?.sourceStoreId ?? target?.storeId;
  const matchesStore = (record) => (
    sourceStoreId === undefined || sourceStoreId === null || sourceStoreId === ""
      ? true
      : sameId(record.storeId || 1, sourceStoreId)
  );

  if (sourceId !== undefined && sourceId !== null && sourceId !== "") {
    return (records || []).find((record) => (
      sameId(record.id, sourceId) && matchesStore(record)
    )) || null;
  }

  const targetPhone = phoneKey(target?.phone);
  if (!targetPhone) return null;
  return (records || []).find((record) => (
    matchesStore(record)
    && phoneFields.some((field) => phoneKey(record[field]) === targetPhone)
  )) || null;
}